import script from "./variation_radiolist_image.vue?vue&type=script&setup=true&lang=js"
export * from "./variation_radiolist_image.vue?vue&type=script&setup=true&lang=js"

import "./variation_radiolist_image.vue?vue&type=style&index=0&id=0ed25d25&scoped=true&lang=css"

import exportComponent from "/var/www/html/obelle-form-order/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ed25d25"]])

export default __exports__